export default function isCustomerBlocked(customer) {
  const { status } = customer;
  return (status === 'blocked');
}
